// 抢单大厅页面
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from '@/i18n';
import { getOrderList, grabOrder } from '@/api/airportTransfer';
import { Toast, ListView, PullToRefresh } from "antd-mobile";
import OrderCard from '../components/OrderCard';
import './OrderHall.scss';

const OrderHall = () => {
  const history = useHistory();
  const t = useTranslation();
  const [orderHallData, setOrderHallData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0
  });

  // 创建ListView的数据源
  const dataSource = new ListView.DataSource({
    rowHasChanged: (r1, r2) => r1 !== r2,
  });

  // 获取抢单大厅数据
  const fetchOrderHallData = async (pageNo = 1, isLoadMore = false) => {
    setLoading(true);
    try {
      const response = await getOrderList({
        orderStatus: 1,
        paymentStatus: 1,
        pageNo,
        pageSize: pagination.pageSize,
        countFlag: true,
        orderSource: 1 // 1-app下单
      });
      
      if (response && response.data && response.data.code === 200) {
        const newData = response.data.data.datas || [];
        newData.forEach(e => {
          e.price = e.price ? (e.price / 100).toFixed(2) : '0.00';
        });
        
        if (isLoadMore) {
          setOrderHallData(prevData => [...prevData, ...newData]);
        } else {
          setOrderHallData(newData);
        }
        
        setPagination({
          ...pagination,
          pageNo: response.data.data.currentPage || pageNo,
          total: response.data.data.total || 0
        });
      } else if (response.data && response.data.errorMsg) {
        console.error(response.data.errorMsg);
        Toast.offline(response.data.errorMsg, 2);
      }
    } catch (error) {
      console.error('获取抢单大厅数据失败', error);
      Toast.offline(t('airportTransfer.error.fetchFailed'), 2);
    } finally {
      setLoading(false);
    }
  };

  // 抢单处理
  const handleGrabOrder = async (orderId) => {
    Toast.loading(t('airportTransfer.hall.grabbing'), 0, () => {}, true);
    try {
      const response = await grabOrder(orderId);
      Toast.hide();
      if (response && response.data && response.data.code === 200) {
        Toast.success(t('airportTransfer.hall.grabSuccess'), 2, () => {
          // 跳转到接单记录页面
          history.push('/airportTransfer/record');
        });
        fetchOrderHallData(1, false);
      } else {
        console.error('抢单失败', response);
        Toast.fail(t('airportTransfer.hall.grabFailed') + ': ' + (response?.data?.errorMsg || t('airportTransfer.error.unknown')), 2);
      }
    } catch (error) {
      console.error('抢单出错', error);
      Toast.hide();
      Toast.fail(t('airportTransfer.hall.grabError'), 2);
    }
  };

  // 处理加载更多
  const handleLoadMore = (pageNo) => {
    fetchOrderHallData(pageNo, true);
  };

  // 渲染每一行数据
  const renderRow = (order) => (
    <OrderCard
      key={order.orderId}
      order={order}
      type="hall"
      onAction={handleGrabOrder}
    />
  );

  // 渲染底部加载提示
  const renderFooter = () => (
    <>
      {loading ? (
        <div className="loading-more">{t('airportTransfer.list.loadingMore')}</div>
      ) : (
        pagination.pageNo * pagination.pageSize >= pagination.total ? (
          <div className="loading-no-more">{t('airportTransfer.list.noMore')}</div>
        ) : null
      )}
    </>
  );

  const onEndReached = () => {
    if (!loading && pagination.pageNo * pagination.pageSize < pagination.total) {
      handleLoadMore(pagination.pageNo + 1);
    }
  };

  // 初始加载数据
  useEffect(() => {
    fetchOrderHallData(1, false);
  }, []);

  return (
    <div className="order-hall-page">
      {/* <div className="page-header">
        <button className="back-btn" onClick={() => history.goBack()}>
          ← 返回
        </button>
        <h1 className="page-title">抢单大厅</h1>
        <div className="header-placeholder"></div>
      </div> */}

      <div className="order-list-container">
        {orderHallData.length === 0 && !loading ? (
          <div className="empty-container">
            <div className="empty-icon">📭</div>
            <div className="empty-text">{t('airportTransfer.hall.emptyText')}</div>
            <div className="empty-tips">{t('airportTransfer.hall.emptyTips')}</div>
          </div>
        ) : (
          <ListView
            dataSource={dataSource.cloneWithRows(orderHallData)}
            renderRow={renderRow}
            renderFooter={renderFooter}
            style={{ height: 'calc(100vh - 1.2rem)', overflow: 'auto' }}
            pageSize={pagination.pageSize}
            onEndReached={onEndReached}
            onEndReachedThreshold={10}
            scrollRenderAheadDistance={500}
            initialListSize={pagination.pageSize}
            pullToRefresh={
              <PullToRefresh
                refreshing={loading}
                onRefresh={() => fetchOrderHallData(1, false)}
                distanceToRefresh={25}
                indicator={{
                  activate: t('airportTransfer.pull.activate'),
                  deactivate: t('airportTransfer.pull.deactivate'),
                  release: t('airportTransfer.pull.release'),
                  finish: t('airportTransfer.pull.finish'),
                }}
              />
            }
          />
        )}
      </div>
    </div>
  );
};

export default OrderHall;
